// @flow
let worker: ?Worker = null

export function terminate () {
  if (worker) {
    console.warn('Terminating Shapes Worker')
    worker.terminate()
    worker = null
  }
}

export function initialize (): Worker {
  if (worker) {
    terminate()
  }

  console.warn('Initializing Shapes Worker')

  // $FlowFixMe
  const ShapeWorker = require('worker-loader?name=[hash].shapes.wrkr.js!./worker.js')
  worker = new ShapeWorker()
  return worker
}

export function getWorker (): Worker {
  if (worker) {
    return worker
  }

  return initialize()
}

export default {
  terminate,
  initialize,
  getWorker,
}
